/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Board/view.blocks to change it.
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Board({
  children,
  viewPath = "/DesignSystem/TasksFilters/Board",
  boardId
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
 boardId={boardId}
/>
{children}
</React.Fragment>)
}